import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import H from './H';

export default class HExample extends Component {

  state = {
    count: 16,
    level: 3,
  };

  onChange = e => this.setState(e.target.value);

  render() {
    const { level } = this.state;

    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={H.defaultProps} propTypes={H.propTypes} propValues={this.state}/>
        <div className="example-header">
          <H {...this.state}>This is a dynamic header of level {!isNaN(level) ? level : 3 }</H>
        </div>
        <SourceCode querySelector=".example-header .core-h"/>
      </Example>
    );
  }

}
